export const Networks = {
    bsc: {
        id: 97,
        rpc: 'https://data-seed-prebsc-1-s1.binance.org:8545/'
    }
}